<template>
    <div>
        <div class="contain">
            <div class="conLeft">
                <div class="conTop">
                    <div class="imageItem" v-for="item,index in showimages" :style="`width:150px;height:150px`" @click="editImage(item,index)">
                      <img class="imgs" v-img-url="item.file_path" alt="file_path" :style="item.checked?'border:1px solid #409EFF' : ''" />
                    </div>
                </div>
                <div class="conBottom">
                    <el-button @click="back">返回</el-button>
                    <el-button type="primary" @click="toNext">下一步</el-button>
                </div>
            </div>
            <div class="conRight">
                <div class="ctitle">
                    产品类型
                </div>
                <div class="cContent">
                    <div class="citem" v-for="item,index in array" v-text="item.name" :style="item.checked?'background:#409EFF;color:#fff' : '' " @click="changeProduct(item,index)"></div>
                </div>
                <div class="ctitle">
                    产品子类型
                </div>
                <div class="cContent">
                    <div class="citem" v-for="item,index in list" v-text="item.name" :style="item.checked?'background:#409EFF;color:#fff' : '' " @click="changeCate(item,index)"></div>
                </div>
               <div class="ctitle">
                    设置高度
                </div>
                <div class="cContent">
                    <div class="citem cinp">
                        <el-input v-model="showimages[cur3].height"></el-input>mm
                    </div>
                </div>
                <div class="ctitle">
                    设置宽度
                </div>
               <div class="cContent">
                    <div class="citem cinp">
                        <el-input v-model="showimages[cur3].width"></el-input>mm
                    </div>
                </div>
                <div class="cContent mp20">
                    <el-button @click="confirm" type="primary">确认</el-button>
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
    import StoreApi from '@/api/store.js';
    import qs from 'qs';
    import Upload from "@/components/file/Upload";
    import draggable from "vuedraggable";
    export default {
        components: {
            Upload,
            draggable
        },
        data() {
            return {
               array:[],
               list:[],
               showimages:[],
               cur3:0,
               cur1:0,
               cur2:0,
               order:[]
            };
        },
        created() {
            let that = this
            let str = localStorage.getItem("params")
            let order = localStorage.getItem("orderparams")
            if(order){
                 that.order = JSON.parse(order)
            }
            let array = JSON.parse(str)
            console.log(array)
            that.init(array)
            // that.array = array
        },
        methods: {
            // 选择商品
            changeProduct(item,index){
                let that = this 
                console.log(item,index)
                console.log(this.array)
                
                that.array.forEach((v,i) => {
                    if(i == index){
                        v.checked = true
                        v.list.forEach((value,index) => {
                            if(index == 0){
                                value.checked = true
                                value.images.forEach((val,idx) => {
                                    if(idx == 0){
                                        val.checked = true
                                    }else{
                                        val.checked = false
                                    }
                                })
                                
                            }else{
                                value.checked = false
                            }
                        })
                        that.list = v.list
                        let tep = v.list[0].images
                        that.cur3 = 0
                        that.showimages = tep
                        that.cur1 = i
                    }else{
                        v.checked = false
                    }
                })
            },
            // 选择子分类
            changeCate(item,index){
                let that = this 
                that.list.forEach((v,i) => {
                    if(i == index){
                        v.checked = true
                        v.images.forEach((val,idx) => {
                            if(idx == 0){
                                val.checked = true
                            }else{
                                val.checked = false
                            }
                        })
                        let tep = v.images
                        that.showimages = tep
                        that.cur2 = index
                    }else{
                        v.checked = false
                    }
                })
            },
            // 编辑图片
            editImage(item,index){
                let that = this 
                that.showimages.forEach((v,i) => {
                    if(i == index){
                        v.checked = true
                        that.cur3 = index
                    }else{
                        v.checked = false
                    }
                    
                })
            },
            confirm(){
                // this.cur3 = 0
            },
            init(array){
                let that = this
                let temp = []
                array.forEach((v,i) => {
                    let list = []
                    v.children.forEach((value,index) => {
                        if(value.images.length > 0){
                            list.push(value)
                        }
                    })
                    v.list = list
                    v.att = []
                    v.totalPrice = 0
                    v.list.forEach((values,idx) => {
                        if(idx == 0){
                             values.checked = true
                        }else{
                             values.checked = false
                        }
                       
                    })
                    if(i == 0){
                        v.checked = true
                    }else{
                        v.checked = false
                    }
                })
                that.array = array
                that.list = that.array[0].list
                that.showimages = that.array[0].children[0].images
                that.showimages[0].checked = true
            },
            toNext(){
                let that = this 
                let tos = [...that.order,...that.array]
                let str = JSON.stringify(tos)
                localStorage.setItem('orderparams',str)
                this.$router.push('/store/placeorder/order');
            },back(){
                this.$router.back(-1);
            }
        }
    };
</script>

<style>
    .mp20{
        margin-top: 20px;
    }
    .cinp{
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        padding: 10px !important;
    }
    .contain{
        display: flex;
        
    }
    .imageItem{
        cursor: pointer;
        margin: 0 20px;
    }
    .imgs{
        width: 100%;
        height: 100%;
    }
    .conRight{
        width: 200px;
        height: 80vh;
        overflow-y: auto;
    }
    .conTop{
        width: 70vw;
        height: 80vh;
        /* background: red; */
        border: 1px solid #aaa;
       display: flex;
        justify-content: center;
        align-items: center;
    }
    .conBottom{
        display: flex;
        justify-content: center;
        padding-top: 20px;
        border-top: 1px solid #aaa;
    }
    .ctitle{
        text-align: center;
        padding: 5px 0;
        font-size: 16px;
        font-weight: bold;
        border-bottom: 1px solid #aaa;
    }
    
    .citem{
        text-align: center;
        padding: 8px 0;
        border-bottom: 1px solid #999;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/views/store/placeorder/edit copy.vue